"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.dataPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = require("@mmc/text");

// eslint-disable-next-line import/prefer-default-export
var dataPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  paragraph: _propTypes["default"].string,
  sectionHeading: _propTypes["default"].string,
  mainHeading: _propTypes["default"].string,
  theme: _propTypes["default"].oneOf(['light', 'dark']),
  headingTag: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});

exports.dataPropType = dataPropType;